exports.f = {}.propertyIsEnumerable;


//////////////////
// WEBPACK FOOTER
// /home/justin/dev/todomvc-liveresource-website/~/core-js/modules/_object-pie.js
// module id = 100
// module chunks = 0